import React from "react";
import { useMoodsContext } from "store/contexts/moodsContext";
import ProgressBar from "components/Progressbar";

var styles = {
  selectedEmojiImg: {
    height: "20px",
    width: "20px",
  },
};

const EmojiAndProgressbar = ({
  checkstats,
  classPercentage,
  bgcolor,
  color,
}) => {
  const { moods } = useMoodsContext();
  const classes = styles;

  return (
    <div style={{ marginTop: ".5rem" }}>
      {moods.map((mood, index) => (
        <div className="overall-stats pt-1" key={mood.id}>
          <img
            style={classes.selectedEmojiImg}
            src={mood.media}
            alt={`${mood.name}`}
          />
          <ProgressBar
            color={color}
            completed={checkstats[index]?.mood_avg}
            progressPercentage={checkstats[index].mood_avg}
            height={7}
            bgcolor={bgcolor}
          />
          <div></div>
        </div>
      ))}
    </div>
  );
};
export default EmojiAndProgressbar;
